import {Platform, StatusBar, View} from 'react-native';
import SingleUserInfoComponent from '~components/SingleUserInfoComponent';

const SingleUserInfo = () => {
  return (
    <View style={{flex: 1}}>
      <SingleUserInfoComponent />
    </View>
  );
};

export default SingleUserInfo;
